import { NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { GridModule } from '@progress/kendo-angular-grid';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { TooltipsModule } from "@progress/kendo-angular-tooltip";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { IntlModule } from "@progress/kendo-angular-intl";
import { FileSelectModule } from '@progress/kendo-angular-upload';

const KENDO_MODULES = [
  ButtonsModule,
  LayoutModule,
  RippleModule,
  TooltipsModule,
  IntlModule,
  TypographyModule,
  InputsModule,
  IndicatorsModule,
  LabelModule,
  DropDownsModule,
  IconsModule,
  GridModule,
  DateInputsModule,
  FileSelectModule
];

@NgModule({
  declarations: [],
  imports: [],
  exports: [...KENDO_MODULES],
})
export class KendoModule {}
